/* eslint-disable react-hooks/set-state-in-effect */
import { useCallback, useEffect, useState } from 'react'
import { kanbify } from '../lib/kanbifyClient'

export function useTimeLogs(cardId) {
    const [logs, setLogs] = useState([])
    const [loading, setLoading] = useState(true)

    const fetch = useCallback(async () => {
        if (!cardId) { setLogs([]); setLoading(false); return }
        setLoading(true)
        const { data } = await kanbify
            .from('time_logs')
            .select('*')
            .eq('card_id', cardId)
            .gt('duration_minutes', 0)
            .order('created_at', { ascending: false })
        setLogs(data || [])
        setLoading(false)
    }, [cardId])

    useEffect(() => { fetch() }, [fetch])

    // Stable ref: CardDetail autosave/recovery effects depend on this function.
    // Recreating it on every render caused duplicate time_logs in the past.
    const addTimeLog = useCallback(async (durationMinutes, description = null) => {
        const { data, error } = await kanbify.rpc('add_time_log', {
            p_card_id: cardId,
            p_duration_minutes: durationMinutes,
            p_description: description || null,
        })
        if (!error && data?.success) {
            await fetch()
            return { success: true }
        }
        return {
            success: false,
            error: data?.error || error?.message || 'Nu s-a putut salva sesiunea.',
        }
    }, [cardId, fetch])

    return { logs, loading, fetch, addTimeLog }
}

export function useAverageTaskTime(cardId) {
    const [averageMinutes, setAverageMinutes] = useState(0)
    const [loading, setLoading] = useState(true)

    const fetch = useCallback(async () => {
        if (!cardId) {
            setAverageMinutes(0)
            setLoading(false)
            return
        }
        setLoading(true)
        const { data, error } = await kanbify.rpc('calculate_average_task_time', { p_card_id: cardId })
        if (!error && data != null) {
            setAverageMinutes(data)
        } else if (error) {
            setAverageMinutes(0)
        }
        setLoading(false)
    }, [cardId])

    useEffect(() => { fetch() }, [fetch])

    return { averageMinutes, loading, fetch }
}
